import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { clientsField } from "../../../data/DynamicForm/FormFields/ClientsFormFields";
import { generateAndExecuteMutation, graphqlQuery } from "../../../data/Axios/DynamicService";
import { customerservice, setupManagementUrl } from "../../../config";
import { CustomerTypesQuery } from "../../../data/Axios/queries";

//const base_url = "https://localhost:7048/graphql/";
const base_url = customerservice.uri;

const IndividualClientsForm = (props) => {
  const [CustomerTypes, setCustomerTypes] = useState([])
  const [loading, setLoading] = useState(true);
  
  const initialValues = {
    id: props.data ? props.data.id : null,
    customerName: props.data ? props.data.customerName : "",
    phoneNumber: props.data ? props.data.phoneNumber : "",
    email: props.data ? props.data.email : "",
    discount: props.data ? props.data.discount : null,
    customerTypeId: props.data ? props.data.customerTypeId : "", // Default value
    customerLocation: props.data ? props.data.customerLocation : "",
    customerAlias: props.data ? props.data.customerAlias : "",
    customerPostalAddress: props.data ? props.data.customerPostalAddress : "",
    customerNationalIdNumber: props.data ? props.data.customerNationalIdNumber : "",
  };

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  useEffect(() => {
        async function fetchAllData() {
          try {
            const Response = await graphqlQuery(
              CustomerTypesQuery,
              setupManagementUrl.uri
            );
            if (Response) {
              setCustomerTypes(Response || []);
            }
            
          } catch (error) {
            console.error("Error fetching data:", error);
          } finally {
            setLoading(false);
          }
        }
    
        fetchAllData();
      }, [props.data]);

  // Define Customer Type Options
  const CustomerTypeOptions = CustomerTypes
  ? CustomerTypes.map((type) => ({
      parent_key: type.id,
      value: type.id,
      label: type.typeName,
    }))
  : [];

  const baseFields = [
    ...clientsField,
    {
      name: "customerTypeId",
      label: "Customer Type *",
      type: "select",
      gridColumn: "span 2",
      options: CustomerTypeOptions,
      required: false,
    },
    {
      name: "discount",
      label: "Set Customer Specific Discount",
      type: "number",
      gridColumn: "span 2",
      options: CustomerTypeOptions,
      required: false,
    },
  ];
  const optionalFields = [
    {
      name: "customerLocation",
      label: "Customer Location",
      type: "text",
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "customerAlias",
      label: "Customer Alias",
      type: "text",
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "customerPostalAddress",
      label: "Customer Postal Address",
      type: "text",
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "customerNationalIdNumber",
      label: "Customer National ID Number",
      type: "text",
      gridColumn: "span 2",
      required: false,
    },
  ];

  // Optional fields are always visible on the form.
  const Fields = [...baseFields, ...optionalFields];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        customerName,
        email,
        phoneNumber,
        discount,
        customerTypeId,
        customerLocation,
        customerAlias,
        customerPostalAddress,
        customerNationalIdNumber,
      } =
        values;
      const Discount = discount === "" || discount === null || discount === undefined
        ? null
        : parseFloat(discount);
      const CustomerTypeId = parseInt(customerTypeId || 0);
      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            customerName,
            email,
            phoneNumber,
            discount: Discount,
            customerTypeId: CustomerTypeId,
            customerLocation,
            customerAlias,
            customerPostalAddress,
            customerNationalIdNumber,
            companyId: companyId,
            updatedBy: userId,
          }
        : {
            customerName,
            email,
            phoneNumber,
            discount: Discount,
            customerTypeId: CustomerTypeId,
            customerLocation,
            customerAlias,
            customerPostalAddress,
            customerNationalIdNumber,
            companyId: companyId,
            createdBy: userId,
          };


      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCustomers" : "createcustomers",
        mutationData,
        "customers",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Customer ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <div>
      <DynamicForm
        initialValues={initialValues}
        fields={Fields}
        onSubmit={handleSubmit}
        title={props.isEditing ? "Edit Customer" : "Create Customer"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Customer"
            : "Create a New Customer"
        }
      />
    </div>
  );
};

export default IndividualClientsForm;
